<template>
<div >
	<Navbar></Navbar>

	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card">
				<div class="card-body">

			
					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Vehículos</li>
						</ol>
						<div class="title">
							<h1>Vehículos</h1>
						</div>
						
						<div class="cta">
							<div @click="exportData()" class="dropdown-item" >Exportar listado</div>

							<!-- <router-link :to="`/cars/import`" tag="a" class="btn btn-light " >Precargar vehículos</router-link>
							<router-link :to="`/cars/request-dispatch`" tag="a" class="btn btn-light " >Solicitar despachos</router-link>
							<router-link :to="`/cars/request-pre-delivery`" tag="a" class="btn btn-light " >Solicitar pre entregas</router-link>
							<router-link :to="`/cars/request-delivery`" tag="a" class="btn btn-light " >Solicitar entregas</router-link> -->

							<!-- <b-dropdown text="Acciones " right  variant="light" >
								<router-link :to="`/cars/import`" tag="a" class="dropdown-item" >Precargar vehículos</router-link>
								<router-link :to="`/cars/request-dispatch`" tag="a" class="dropdown-item" >Solicitar despachos</router-link>
								<router-link :to="`/cars/request-pre-delivery`" tag="a" class="dropdown-item" >Solicitar pre entregas</router-link>
								<router-link :to="`/cars/request-delivery`" tag="a" class="dropdown-item" >Solicitar entregas</router-link>
							</b-dropdown> -->

						</div>
					</div>

			
					<div class="filters-box">
						<div class="filter">
							<label>BUSCAR</label>
							<input 
								type="text" 
								class="form-control" 
								placeholder="Buscar" 
								v-model="filters.search" 
								@keyup.enter="updateFilters($event)">
						</div>
						
						<div class="filter">
							<label>Estado</label>
							<select class="form-control" 
								v-model="filters.status" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option value="PRE_ADMITTED">Pre ingresados</option>
								<!-- <option value="ADMITTED">En depósito temporal</option> -->
								<div class="dropdown-divider"></div>
								<option value="IN_CUSTOMS_DEPOSIT">Depósito fiscal</option>
								<option value="CUSTOMS_DISPATCH_PENDING"> - Sin despachar</option>
								<option value="CUSTOMS_DISPATCHED"> - Despachados</option>
								<div class="dropdown-divider"></div>
								<option value="IN_NATIONAL_DEPOSIT">Depósito nacional</option>
								<option value="PRE_DELIVERY_PENDING"> - Sin pre-entrega</option>
								<option value="PRE_DELIVERY_DONE"> - Pre entregas realizada</option>
								<div class="dropdown-divider"></div>
								<option value="DELIVERY_REQUESTED">Entregas solicitadas</option>
								<option value="DELIVERY_SCHEDULED">Entregas programadas</option>
								<option value="DELIVERED">Entregados</option>
							</select>           
						</div>
						
						<div class="filter">
							<label>Cliente</label>
							<select class="form-control" 
								v-model="filters.client_id" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option v-for="client in clients" :key="client.id" :value="client.id">{{client.name}}</option>
							</select>           
						</div>

					</div>
				
					<table class="table table-clickeable">
						<tr class="table-head">
							<td>Chasis</td>
							<td>Vehículo</td>
							<td>Cliente</td>
							<td>Estado</td>
						</tr>
						
						<router-link tag="tr" v-for="item of list" :key="item.id" :to="`/cars/${item.id}`" >
							<td>{{item.chassis_number}}</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.brand.title}}</span>
									<span >{{item.model}}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.client.name}}</span>
									<span >{{item.client.business_name}}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
									
									<span v-if="item.status=='PRE_ADMITTED' && item.admission_estimated_at" style="margin-left: 15px;">Ingreso estimado: {{item.admission_estimated_at | moment("DD-MM-YYYY")}}</span>
									<span v-if="item.status=='ADMITTED'" style="margin-left: 15px;">{{item.joined_at | moment("DD-MM-YYYY")}}</span>
									
									<span v-if="item.status == 'DELIVERY_REQUESTED' && item.delivery_requested_at" style="margin-left: 15px;">
										{{item.delivery_requested_at | moment("DD-MM-YYYY")}}
									</span>
									<span v-if="item.status == 'DELIVERY_SCHEDULED' && item.delivery_scheduled_at" style="margin-left: 15px;">
										{{item.delivery_scheduled_at | moment("DD-MM-YYYY [a las] HH:mm")}}
									</span>
									<span v-if="item.status == 'DELIVERED' && item.delivered_at" style="margin-left: 15px;">
										{{item.delivered_at | moment("DD-MM-YYYY")}}
									</span>
									<span v-if="item.authorized" class="badge badge-success w-auto ml-3" >Autorizado</span>
								</div>
							</td>
						</router-link>
						
					</table>

					<div class="alert alert-info text-center" v-if="list.length==0" >No se han encontrado vehículos</div>
					
					<vue-ads-pagination v-if="pagination"
						:total-items="pagination.total"
						:max-visible-pages="2"
						:items-per-page="pagination.length"
						:page="pagination.page-1"
						@page-change="pageChange"					
					></vue-ads-pagination>
		
				</div>
			</div>
		</div>
	</div>
	

	<CarPreview ref="carPreview"></CarPreview>
	
</div>
</template>

<script>
import gql from 'graphql-tag'
import listMixins from '@/mixins/listMixins'
import { mapGetters } from 'vuex'
import { buildExportUrl } from '@/lib/exportsUrl'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import CarPreview from '@/views/cars/CarPreview'

export default {
	name: 'cars',
	components:{
		Navbar,
		Loader,
		CarPreview,
	},
	mixins:[listMixins],
	data () {
		return {
			list:[],
			clients:[],
			loading: true,
		}
	},
	computed:{
		...mapGetters(['loggedUser'])
	},
	beforeMount(){
		this.filters = this.getValidUrlParams();
		this.fetchaData();
		this.load();
	},
	methods:{
		exportData(){
			window.open(buildExportUrl('export-user-cars', {
				...this.$route.query,
				user_code: this.loggedUser.code,
			}), '_blank');
		},
		fetchaData(){
			this.$apollo.query({
				query: gql`query ($id: ID! ) {
					user(id: $id) {
						id
						clients{
							id
							name
						}
					}
				}`,
				variables: {
					id: this.loggedUser.id,
				},
				fetchPolicy: 'no-cache'
			})
			.then(({data}) => {
				this.clients = data.user.clients;
			});
		},
		load(){
			this.$apollo.query({
				query: gql`query ($first: Int!, $page: Int, $search: String, $status: String, $client_id: ID) {
					cars(first: $first, page: $page, search: $search, status: $status, client_id: $client_id) {
						paginatorInfo {
							count
							currentPage
							total
						}
						data {
							id
							client{
								name
								business_name
							}
							brand{
								title
							}
							model
							motor_number
							chassis_number
							admission_estimated_at
							delivery_requested_at
							delivery_scheduled_at
							authorized
							status
							statusText								
						}
					}
				}`,
				variables: {
					page: this.pagination.page,
					first: this.pagination.length,
					search: this.filters.search,
					status: this.filters.status,
					client_id: this.filters.client_id,
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.list = data.data.cars.data;
				this.pagination.total = data.data.cars.paginatorInfo.total;
				this.loading = false
			});
		},
		openPreview(id){
			this.$refs.carPreview.open(id)
		},
	}
}

</script>

<style>

</style>
